module.exports = __webpack_public_path__ + "img/landscape-8.3de71064.jpg";